import { Position } from 'lib/_types'
import { ContextSchema, SchemaDetail, schemaPath } from './types'

// Schema for a screen scroll event. A nagative value indicates screen is moving up or moving left.
const SCROLL_SCHEMA: SchemaDetail = {
  vendor: 'space.yay',
  name: 'scroll',
  format: 'jsonschema',
  version: '1-0-0',
}

export type ScrollContextSchemaData = {
  distance: number
  direction: 'horizontal' | 'vertical' // Direction of scrolled contents.
}

export const scrollContextSchema = (
  data: ScrollContextSchemaData
): ContextSchema<ScrollContextSchemaData> => ({
  schema: schemaPath(SCROLL_SCHEMA),
  data,
})

export const positionToScrollContextSchema = (
  diff: Position
): ScrollContextSchemaData => ({
  distance: Math.floor((diff.x || diff.y) ?? 0),
  direction: diff.x === 0 ? 'vertical' : 'horizontal',
})
